/** Testi dell'area partecipante: percorso, webinar, conferme, link email. */
export const percorsi = {
  titolo: 'Il mio percorso',
  saluto: (nome: string) => `Ciao, ${nome}`,
  iscrittoDal: (data: string) => `Iscritto dal ${data}`,
  nessunPercorsoTitolo: 'Non sei ancora iscritto a un percorso',
  nessunPercorsoTesto: 'Quando l’organizzatore ti iscrive, il programma compare qui e ricevi un’email.',
  nessunWebinarTitolo: 'Nessun webinar in programma',
  nessunWebinarTesto: 'I webinar del tuo percorso compariranno qui appena l’organizzatore li pubblica.',
  promemoriaInviti: 'Ricevi un invito via email 7 giorni prima di ogni lezione: confermi con un clic, anche da qui.',
  relatori: (nomi: string[]) => (nomi.length === 0 ? '' : nomi.length === 1 ? `Relatrice o relatore: ${nomi[0]}` : `Relatori: ${nomi.join(', ')}`),
  stati: {
    invitato: 'Da confermare',
    confermatoOnline: 'Confermato online',
    confermatoSala: 'Confermato in sala',
    rinunciato: 'Hai rinunciato',
    nonInvitato: 'Inviti non ancora inviati',
    chiuso: 'Concluso',
  },
  azioni: {
    conferma: 'Conferma la partecipazione',
    entra: 'Entra in aula',
    dettagli: 'Dettagli',
  },
  dialogo: {
    titolo: 'Come parteciperai?',
    descrizione: 'Scegli dove seguirai la lezione. Puoi cambiare idea fino all’inizio del webinar.',
    online: 'Online',
    onlineTesto: 'Dal tuo computer o telefono, con il video del relatore e le slide.',
    sala: 'In sala',
    salaTesto: 'Di persona. Il giorno della lezione registri l’ingresso dall’app.',
    annulla: 'Annulla',
    inCorso: 'Salvataggio in corso',
  },
  dettaglio: {
    titoloPagina: 'Webinar',
    torna: 'Torna al percorso',
    quando: 'Quando',
    durata: (min: number) => `Durata ufficiale: ${min} minuti`,
    relatori: 'Relatori',
    nessunRelatore: 'I relatori saranno annunciati a breve.',
    laTuaConferma: 'La tua partecipazione',
    confermatoOnline: 'Parteciperai online.',
    confermatoSala: 'Parteciperai in sala.',
    rinunciato: 'Hai rinunciato a questo webinar.',
    invitato: 'Non hai ancora confermato.',
    nonInvitato: 'L’invito arriva 7 giorni prima della lezione.',
    cambiaIdea: 'Puoi cambiare idea fino all’inizio del webinar.',
    cambiaModalita: 'Cambia modalità',
    rinuncia: 'Rinuncia',
    riconferma: 'Partecipa di nuovo',
    rinunciaTitolo: 'Vuoi rinunciare?',
    rinunciaTesto: 'Libererai il posto. Potrai confermare di nuovo fino all’inizio del webinar.',
    rinunciaConferma: 'Sì, rinuncio',
    salvato: 'Scelta salvata.',
    aulaPresto: 'L’aula si apre un’ora prima dell’inizio. Torna qui il giorno del webinar.',
  },
  link: {
    titolo: 'Conferma la partecipazione',
    saluto: (nome: string) => `Ciao ${nome}, ti aspettiamo a:`,
    nonValido: 'Questo link non è più valido',
    nonValidoTesto: 'Forse è già stato usato o il webinar è passato. Accedi ad Aulaviva per vedere il tuo percorso.',
    vaiAlPercorso: 'Vai al mio percorso',
    online: 'Partecipo online',
    sala: 'Partecipo in sala',
    rinuncia: 'Non partecipo',
    esitoOnline: 'Confermato: parteciperai online.',
    esitoSala: 'Confermato: parteciperai in sala.',
    esitoRinuncia: 'Abbiamo registrato la tua rinuncia.',
    esitoTesto: 'Puoi cambiare idea fino all’inizio del webinar, da questa pagina o dal tuo percorso in Aulaviva.',
    giaScelto: (stato: string) => `Scelta attuale: ${stato}. Puoi cambiarla qui sotto.`,
  },
  completa: {
    titolo: 'Completa l’iscrizione',
    sottotitolo: (nome: string, percorso: string) => `Ciao ${nome}, l’organizzatore ti ha iscritto a “${percorso}”. Scegli una password per entrare.`,
    azione: 'Scegli la password ed entra',
    inCorso: 'Un momento',
    nonValido: 'Questo link non è più valido',
    nonValidoTesto: 'Il link scade dopo 7 giorni o se l’iscrizione è già stata completata. Prova ad accedere o chiedi un nuovo link all’organizzatore.',
    vaiAllAccesso: 'Vai all’accesso',
  },
  registrazionePercorso: (titolo: string) => `Ti stai iscrivendo a “${titolo}”.`,
  registrazionePercorsoChiusa: 'Le iscrizioni a questo percorso sono chiuse. Puoi comunque creare il tuo account.',
};
